import type { FC } from 'react';
import { BreakContinueKeywordsWrapper } from './BreakContinueKeywords.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface BreakContinueKeywordsProps {}

const BreakContinueKeywords: FC<BreakContinueKeywordsProps> = () => (
<BreakContinueKeywordsWrapper>	
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Break &amp; Continue Keywords</h1>			
   </header>
   <br/>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify"><strong>Break :</strong></p>
      <ul className="text-align-justify">
         <li>To break a loop or&nbsp;a switch&nbsp;statement, we use the break keyword.</li>
         <li>When a break statement encounters, the loop terminates immediately, and as a result, the program control goes to the next statement following the loop.</li>
         <li>When a break statement encounters inside a switch statement, it terminates a case, and the program control goes to the next statement following the switch statement.</li>
         <li>We should use it when we are not sure about the number of iterations.</li>
         <li>Syntax - 
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'break;'
            }
            </SyntaxHighlighter>
         </li>
      </ul>

      <p className="text-align-justify"><strong>Continue :</strong></p>
      <ul className="text-align-justify">
         <li>To immediately jump to the next iteration of the loop, we use to continue keyword.</li>
         <li>When continue statement encounters inside a for loop, the control immediately jumps to the update statement.</li>
         <li>When continue statement encounters inside a while loop or do/while loop, control immediately jumps to the Boolean expression.</li>
         <li>Therefore, it is useful when we want to continue the loop; however, we do not want the rest of the loop body’s statements to execute for that particular iteration.</li>
         <li>Syntax - 
            <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'continue;'
            }
            </SyntaxHighlighter>
         </li>
      </ul>
   </div>
</BreakContinueKeywordsWrapper>
);

export default BreakContinueKeywords;
